import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../../lib/i18next";
import { ENGAGEMENT_EXPLANATION } from "../../../../locales/keysTranslations";

const ContentEngagement = () => {
  const { t } = useTranslationApp();
  return (
    <React.Fragment>
      <Typography
        color="inherit"
        variant="body1"
        sx={{ fontWeight: 300, mb: 1 }}
      >
        {t(ENGAGEMENT_EXPLANATION)}
      </Typography>
    </React.Fragment>
  );
};

export default ContentEngagement;
